"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var redux_1 = require("redux");
var history_1 = require("history");
var connected_react_router_1 = require("connected-react-router");
var redux_saga_1 = __importDefault(require("redux-saga"));
var i18n_1 = require("Service/i18n");
var router_1 = __importDefault(require("App/router"));
var reducers_1 = __importDefault(require("App/redux/reducers"));
var sagas_1 = __importDefault(require("App/redux/sagas"));
var context_1 = __importDefault(require("App/context"));
// import { logger } from 'redux-logger'
var UserManager_1 = __importStar(require("./util/UserManager"));
// middlewared
var history = history_1.createBrowserHistory({});
var sagaMiddleware = redux_saga_1.default();
var routeMiddleware = connected_react_router_1.routerMiddleware(history);
var middlewares = [sagaMiddleware, routeMiddleware];
var App = function (_a) {
    var name = _a.name, languages = _a.languages, redux = _a.redux, router = _a.router, _b = _a.showBreadcrumb, showBreadcrumb = _b === void 0 ? true : _b, _c = _a.hideTenantSwitch, hideTenantSwitch = _c === void 0 ? false : _c;
    i18n_1.loadI18Next(languages);
    var store = redux_1.createStore(reducers_1.default(history, redux === null || redux === void 0 ? void 0 : redux.reducers), redux_1.compose(redux_1.applyMiddleware.apply(void 0, middlewares)));
    // OIDC Azure integration
    UserManager_1.loadUser(store, UserManager_1.default);
    sagaMiddleware.run(sagas_1.default, redux === null || redux === void 0 ? void 0 : redux.sagas);
    return (react_1.default.createElement(react_redux_1.Provider, { store: store },
        react_1.default.createElement(UserManager_1.OidcProvider, { store: store, userManager: UserManager_1.default },
            react_1.default.createElement(context_1.default, { pages: router.pages || [], name: name, logoBase64: '', logoMimeType: '', showBreadcrumb: showBreadcrumb, hideTenantSwitch: hideTenantSwitch },
                react_1.default.createElement(router_1.default, { history: history, indexUrl: router.indexUrl, pages: router.pages })))));
};
exports.default = App;
//# sourceMappingURL=index.js.map